import { ProposalService } from 'src/app/services/proposal-service';
import { Component, OnInit } from '@angular/core';
import { RemainingVotes } from '../dashboard/note/note.component';
import { OpenSpaceService } from 'src/app/services/open-space.service';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-remaining-votes',
  templateUrl: './remaining-votes.component.html',
  styleUrls: ['./remaining-votes.component.css']
})
export class RemainingVotesComponent implements OnInit {

  myVotes = 0;
  dataSubscription: Subscription;
  openSpaceSelected: number;

  constructor(private storage: StorageMap, private openService: OpenSpaceService,
              private proposalService: ProposalService) { }

  ngOnInit(): void {
    this.watchForOpenSpaceChanged();
    this.watchForProposalVoteChanges();
  }

  watchForOpenSpaceChanged() {
    this.dataSubscription = this.storage.watch('selectedOpenId', { type: 'string' })
      .subscribe((openId) => {
        const openIdInt = parseInt(openId, 10);
        if (!isNaN(openIdInt)) {
          this.openSpaceSelected = openIdInt;
          this.getUserRemainingVotes(openIdInt);

        }
      });
  }

  watchForProposalVoteChanges(){
    this.proposalService.proposalVoteChanged.subscribe((_: any) =>
      this.getUserRemainingVotes(this.openSpaceSelected));

    }

  getUserRemainingVotes(openSpaceId: number){
    this.openService.getOpenSpaceRemainingVotes(openSpaceId).subscribe(
      (data) => {
        const content = JSON.stringify(data);
        const jsonObj: any = JSON.parse(content);
        const remainingVotes: RemainingVotes =  jsonObj as RemainingVotes;
        this.myVotes = remainingVotes.totalVotes;
        this.watchForProposalDelete();
      },
      error => {
        console.error(error);
      }
    );
  }
  watchForProposalDelete(){
    this.proposalService.proposalDeleted.subscribe((_: any) =>
      this.getUserRemainingVotes(this.openSpaceSelected));
  }

}
